import * as actionTypes from "./actionTypes";
import axios from "axios";
import * as apiEndPoints from "../../shared/apiPaths";
import { getErrorMessage } from "../../shared/utils";

export const getTeam = (loading, id, token) => {
  return dispatch => {
    if (loading) {
      return;
    }
    dispatch(getTeamRequest());

    const url = window.ENV.API_ROOT + apiEndPoints.TEAM;
    const config = {
      headers: { Authorization: token.token }
    };

    const data = {
      projectId: id
    };

    axios
      .post(url, data, config)
      .then(response => {      
        dispatch(getTeamSuccess(response.data));
      })
      .catch(error => {
        const status = error.response ? error.response.status : 0;
        dispatch(getTeamFailure(getErrorMessage(error), status));
      });
  };
};

const getTeamRequest = () => {
  return {
    type: actionTypes.TEAM_REQUEST
  };
};

const getTeamSuccess = response => {
  return {
    type: actionTypes.TEAM_SUCCESS,
    response: response
  };
};

const getTeamFailure = (error, status) => {
  return {
    type: actionTypes.TEAM_FAILURE,
    error: error,
    forbidden: status === 403
  };
};
